module.exports = __webpack_public_path__ + "static/media/loading.00d7a8eb.gif";